module.exports = __webpack_public_path__ + "img/apple.74cbc880.svg";